import { http, HttpResponse, } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

export const kymw6901Handlers = [
  http.post(
    PlessService.SERVICE.getClassBuyerId.url,
    () => {
      return HttpResponse.json(getClassBuyerIdResponse);
    }
  ),
  http.post(
    PlessService.SERVICE.getNewGoodsProposalItem.url,
    () => {
      return HttpResponse.json(getNewGoodsProposalItemResponse);
    }
  ),
  http.post(
    PlessService.SERVICE.imagePhotoFileUpload.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.imagePhotoDownload.url,
    () => {
      return HttpResponse.json(imagePhotodownloadResponse);
    }
  ),
  http.post(
    PlessService.SERVICE.KYMW02getSpecifiedFile.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
        obj: {
          FilePath: ''
        }
      });
    }
  ),
  http.post(
    PlessService.SERVICE.registNewGoodsProposal.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
        result: {
          obj: {
            ProposalId: '122'
          }
        }
      });
    }
  ),
  http.post(
    PlessService.SERVICE.updateNewGoodsProposal.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.updateSuggestionStatusRecruiment.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.updateSuggestionStatusRejected.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.getMasterInput.url,
    () => {
      return HttpResponse.json(getMasterInput);
    }
  ),
  http.post(
    PlessService.SERVICE.updateMasterInput.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.registMasterInput.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.registNewGoodsProposalGoods.url,
    () => {
      return HttpResponse.json({
        status: 'ok',
        message: '処理完了',
      });
    }
  ),
  http.post(
    PlessService.SERVICE.getNewGoodsProposal.url,
    () => {
      return HttpResponse.json(getNewGoodsProposalResponse);
    }
  ),
];

const getClassBuyerIdResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        UserNmKanji: 'バイヤーA',
        UserId: '12',
      },
      {
        UserNmKanji: 'バイヤーB',
        UserId: '13',
      },
    ]
  }

};

const getNewGoodsProposalItemResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      ProposalId: '1',
      // ProposalStatus: '1',
      ProposalStatus: '1',
      ClassCode: '01',
      ProposalBuyerId: '12',
      ProposalGoodsName: '商品名Ａ',
      ProposalName: '規格名Ａ',
      JanCode: '12345678901',
      ProposalSalesPoint: 'セールスポイントＡ',
      SuggestedPriceSellingNormal: '1000',
      SuggestedPriceSellingSpecial1: '900',
      SuggestedPriceSellingSpecial2: '850',
      SuggestedPricePurchaseNormal: '500',
      SuggestedPricePurchaseSpecial1: '500',
      SuggestedPricePurchaseSpecial2: '500',
      ConsumeByDate: '0117',
      ConsumeTerm: '0217',
      ExpansionStartSuggestedOrderCode: '2024010',
      ExpansionStartSuggestedCatalog: '20240304',
      SuggestedExpansionDiv: '1',
      SuggestedExpansionDivOther: '',
      CoopCode: ['142', '185'],
      MonthAge: '４',
      ProductionFactory: '生産工場Ａ',
      ManufacturingFactory: '1',
      DeliGoodsStandardCheckedFlg: '1',
      GoodsStandardCheckedOrderFlg: '0',
      TemperatureDiv: '00',
      OrderClientName: '発注先Ａ',
      MakerName: 'メーカーＡ',
      Allergen: '小麦',
      AdditionObject: '添加物Ａ',
      CookingMethod: '調理方法Ａ',
      MdbRegistFlg: '0',
      ShootingOrder: '撮影指示Ａ',
      // ImagePhoto: '',
      ImagePhoto: 'a.png',
      ShootinngImage: '撮影イメージＡ',
      Note: '備考Ａ',
      RejectionReason: '不採用理由Ａ',
      PredictedPoints: '12345'
    }
  }
};

const imagePhotodownloadResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [{
      ImagePhotoUrl: 'xxx',
    }]
  }
};

const getMasterInput = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      MasterInputId: '1',
      PCode: 'P123467',
      ItemCode: '1234567',
      JanCode: '1234567891012',
      GoodsName: '商品名',
      StandardName: '規格名',
      PublishMediumType: '001',
      ClassCode: '10',
      LargeClassCode: '25',
      MiddleClassCode: '2500',
      SmallClassCode: '250001',
      OrderUnitType: '0',
      SetQuantity: '1',
      SuggestedPriceSellingNormal: '100',
      SuggestedPriceSellingSpecial1: '90',
      SuggestedPriceSellingSpecial2: '85',
      SuggestedPricePurchaseNormal: '60',
      SuggestedPricePurchaseSpecial1: '60',
      SuggestedPricePurchaseSpecial2: '60',
      BundlePrice: '10',
      UnitPriceDiv: '0',
      UnitPriceCoefficient: '1',
      UnitPriceUnit: '１０',
      EdlpDiv: '0',
      ConsumeByDate: '1234',
      ConsumeTerm: '1234',
      SetDiv: '0',
      CaseSupplyDiv: '0',
      ArrivalAreaDiv: '00',
      ArrivalGoodsTemp: '0',
      ArrivalAdminDays: '1',
      BrandType: '00',
      EcologyDiv: '00',
      CycleTerm: '00',
      PriceType: '1',
      MakerPrice: '1000',
      CoopCode: ['142', '185'],
      PackagePhotographNum: '',
      PackageDataNum: '',
      PeakPhotographNum: '',
      PeakDataNum: '',
      CookingNecessaryPhotoNum: '',
      CookingNecessaryDataNum: '',
      CookingUnnecessaryPhotoNum: '',
      CookingUnnecessaryDataNum: '',
      MaterialPhotographNum: '',
      MaterialDataNum: '',
      BacksidePhotographNum: '',
      BacksideDataNum: '',
      GoodsExplanation: '商品説明',
      Catchphrase: 'キャッチコピー',
      RecommendComment: 'レコメンド',
      UsefulInfoEnclosure: 'テスト',
      UsefulInfoConfiguration: 'テスト',
      UsefulInfoOther: 'テスト',
      UsefulInfoSize: 'テスト',
      HandlingCaution: 'テスト',
      MarkDiv: ['001'],
      ConsumeTaxRate: '8',
      AlcoholPercentage: '１０',
      FruitJuice: '１０',
      SakeMeterValue: '１０',
      Body: '１０',
      FunctionalOrFoshu: '00',
      LiquorCode: '000',
      AlcoholType: '1',
      ContainerForm: '00',
      ApplyTermStart: '20240124',
      ApplyTermEnd: '20250131',
      SeasonConsumeDiv: '1',
      SeasonConsumeTermStart: '0124',
      SeasonConsumeTermEnd: '0131',
      StinkGoodsDiv: '0',
      ListingGoodsName: 'テスト',
      ListingType: 'テスト',
      ListingContentsQuantity: 'テスト',
      ListingSize: 'テスト',
      ListingSizeCm: 'テスト',
      ListingNumber: 'テスト',
      ListingColor: 'テスト',
      PieceSizeLength: '10',
      PieceSizeWidth: '10',
      PieceSizeHeight: '10',
      PieceWeight: '10',
      CaseSizeLength: '10',
      CaseSizeWidth: '10',
      CaseSizeHeight: '10',
      CaseWeight: '10',
      IngredientInfo: 'テスト',
      IngredientsDisp: 'テスト',
      RelationPcodeOld: 'P1234567',
      SpecialOrderType: '00',
      StockType: '0',
      PdPilingUpDays: '12',
      FactoryAddress1: 'テスト',
      FactoryAddress2: 'テスト',
      FcmcFee: '10',
      // GoodsBaseAdmitStatus: '2', // 商品マスタ承認状態本登録
      GoodsBaseAdmitStatus: '1',
    }
  }
};

export const getMarkDiv = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'ctp321',
        CodeDivName: 'マスタ入力表',
        CodeValue: '001',
        CodeName: '新ジャンル',
        Reserve1: '10',
        Reserve2: '399',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp321',
        CodeDivName: 'マスタ入力表',
        CodeValue: '002',
        CodeName: 'スクリューキャップ',
        Reserve1: '10',
        Reserve2: '400',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp321',
        CodeDivName: 'マスタ入力表',
        CodeValue: '003',
        CodeName: '発泡酒',
        Reserve1: '10',
        Reserve2: '401',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      }
    ]
  }
};

export const getManufacturingFactory = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        CodeDiv: 'ctp268',
        CodeDivName: '生産工場',
        CodeValue: '0',
        CodeName: '新規',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      },
      {
        CodeDiv: 'ctp268',
        CodeDivName: '生産工場',
        CodeValue: '1',
        CodeName: '新規',
        Reserve1: '',
        Reserve2: '',
        ReserveNum1: null,
        ReserveNum2: null,
        SortNum: null,
        StartOrderCode: '',
        EndOrderCode: ''
      }
    ]
  }
};

const getNewGoodsProposalResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      JanCode: '12345678901',
      ProposalGoodsName: '商品名Ａ',
      ProposalName: '規格名Ａ',
      ClassCode: '01',
      SuggestedPriceSellingNormal: '1000',
      SuggestedPriceSellingSpecial1: '900',
      SuggestedPriceSellingSpecial2: '850',
      SuggestedPricePurchaseNormal: '500',
      SuggestedPricePurchaseSpecial1: '500',
      SuggestedPricePurchaseSpecial2: '500',
      ConsumeByDate: '0117',
      ConsumeTerm: '0217',
      CoopCode: ['142', '185'],
    }
  }
};
